export default __webpack_public_path__ + "static/media/1733.a067a8c9.png";